import {
  Box,
  Button,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import styled from "@emotion/styled";
import { useFormAccordo } from "./ContextAccordo";

import { NumericFormat } from "react-number-format";
import UtentiModale from "./lib/UtentiModale";
import AutocompleteSelect from "./lib/AutocompleteSelect";
import { useTheme } from "@mui/system";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

// Tipo fee (% o €): stesso autocomplete per la riga generale e le agenzie
const tipoFeeProps = {
  options: [
    { label: "%", value: 1 },
    { label: "€", value: 2 },
  ],
  fullWidth: false,
  sx: { width: 90, display: "inline-flex", verticalAlign: "middle" },
};

const Agenzie = () => {
  const { formState, dispatch } = useFormAccordo();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [agenziaSelezionata, setAgenziaSelezionata] = useState();

  const [isChecked, setIsChecked] = useState({
    stato: formState.agenzie.every((row) => row.abilitato === 1) ? true : false,
    visibile: formState.agenzie.every((row) => row.visibile === 1)
      ? true
      : false,
    acquistabile: formState.agenzie.every((row) => row.acquistabile === 1)
      ? true
      : false,
  });
  const [tipoFeeAll, setTipoFeeAll] = useState(2);
  const [feeAll, setFeeAll] = useState(0);

  const { stato, visibile, acquistabile } = isChecked;

  const theme = useTheme();

  const handleModal = (nomeAzienda) => {
    setAgenziaSelezionata(nomeAzienda);
    setIsModalOpen(true);
  };

  return (
    <Paper sx={{ mt: "0.5" }}>
      <UtentiModale
        open={isModalOpen}
        setOpen={setIsModalOpen}
        agenziaSelezionata={agenziaSelezionata}
        setAgenziaSelezionata={setAgenziaSelezionata} // Pass only when modal is open
      />

      <TableWrapper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">Agenzia</TableCell>
              <TableCell align="center">Abilitato</TableCell>
              <TableCell align="center">Visibile</TableCell>
              <TableCell align="center">Acquistabile</TableCell>
              <TableCell align="center">Fee Accordo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{
                backgroundColor:
                  theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
              }}
            >
              <TableCell align="left">Controlli Generali</TableCell>
              <TableCell align="center">
                <Switch
                  id="abilitato/Generale"
                  name="abilitato/Generale"
                  checked={stato}
                  onChange={(e) => {
                    const newValue = e.target.checked ? 1 : 0;

                    // Update the local state for the main switch
                    setIsChecked({
                      ...isChecked,
                      stato: e.target.checked,
                    });

                    // Dispatch an action to update all rows in the "agenzie" array
                    dispatch({
                      type: "set_all_agenzie_stato",
                      payload: newValue, // Pass the new value for "abilitato"
                    });
                  }}
                  sx={{
                    "&.MuiSwitch-root .MuiSwitch-switchBase": {
                      color: "#ccc",
                    },
                    "&.MuiSwitch-root .Mui-checked": {
                      color: "#407ad6",
                    },
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <Switch
                  id="visibile/Generale"
                  name="visibile/Generale"
                  checked={visibile}
                  onChange={(e) => {
                    const newValue = e.target.checked ? 1 : 0;

                    // Update the local state for the main switch
                    setIsChecked({
                      ...isChecked,
                      visibile: e.target.checked,
                    });

                    // Dispatch an action to update all rows in the "agenzie" array
                    dispatch({
                      type: "set_all_agenzie_visibile",
                      payload: newValue, // Pass the new value for "abilitato"
                    });
                  }}
                  sx={{
                    "&.MuiSwitch-root .MuiSwitch-switchBase": {
                      color: "#ccc",
                    },
                    "&.MuiSwitch-root .Mui-checked": {
                      color: "#407ad6",
                    },
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <Switch
                  id="acquistabile/Generale"
                  name="acquistabile/Generale"
                  checked={acquistabile}
                  onChange={(e) => {
                    const newValue = e.target.checked ? 1 : 0;

                    // Update the local state for the main switch
                    setIsChecked({
                      ...isChecked,
                      acquistabile: e.target.checked,
                      visibile:
                        isChecked.visibile === false &&
                        e.target.checked === false
                          ? false
                          : true,
                    });

                    // Dispatch an action to update all rows in the "agenzie" array
                    dispatch({
                      type: "set_all_agenzie_acquistabile",
                      controllo: "acquistabile",
                      payload: newValue, // Pass the new value for "abilitato"
                    });
                  }}
                  sx={{
                    "&.MuiSwitch-root .MuiSwitch-switchBase": {
                      color: "#ccc",
                    },
                    "&.MuiSwitch-root .Mui-checked": {
                      color: "#407ad6",
                    },
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <AutocompleteSelect
                  id="tipoFee/Generale"
                  {...tipoFeeProps}
                  value={tipoFeeAll}
                  onChange={(value) => {
                    setTipoFeeAll(value);
                    dispatch({
                      type: "set_all_agenzie_tipoFee",
                      payload: value,
                    });
                  }}
                />
                <NumericFormat
                  customInput={TextField}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  sx={{ width: 100 }}
                  id="fee/Generale"
                  name="fee/Generale"
                  value={feeAll}
                  onValueChange={(e) => {
                    setFeeAll(e.floatValue);
                    dispatch({
                      type: "set_all_agenzie_fee",
                      payload: e.floatValue,
                    });
                  }}
                />
              </TableCell>
            </TableRow>
            {formState.agenzie.map((row) => (
              <Fragment key={row.id}>
                <TableRow>
                  <TableCell>
                    <Typography
                      fontWeight="bold"
                      color="primary"
                      sx={{
                        cursor: "pointer",
                        ":hover": {
                          textDecoration: "underline",
                        },
                      }}
                      onClick={() => handleModal(row.nomeAzienda)}
                    >
                      {row.nomeAzienda}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      name={`abilitato/${row.id}`}
                      id={`abilitato/${row.id}`}
                      checked={row.abilitato === 1 ? true : false}
                      onChange={(e) =>
                        dispatch({
                          type: "set_agenzie",
                          id: row.id,
                          payload: {
                            ...row,
                            abilitato: e.target.checked ? 1 : 0,
                          },
                        })
                      }
                      sx={{
                        "&.MuiSwitch-root .MuiSwitch-switchBase": {
                          color: "#ccc",
                        },
                        "&.MuiSwitch-root .Mui-checked": {
                          color: "#407ad6",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      name={`visibile/${row.id}`}
                      id={`visibile/${row.id}`}
                      checked={row.visibile === 1 ? true : false}
                      onChange={(e) =>
                        dispatch({
                          type: "set_agenzie",
                          id: row.id,
                          payload: {
                            ...row,
                            visibile: e.target.checked ? 1 : 0,
                          },
                        })
                      }
                      sx={{
                        "&.MuiSwitch-root .MuiSwitch-switchBase": {
                          color: "#ccc",
                        },
                        "&.MuiSwitch-root .Mui-checked": {
                          color: "#407ad6",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      name={`acquistabile/${row.id}`}
                      id={`acquistabile/${row.id}`}
                      checked={row.acquistabile === 1 ? true : false}
                      onChange={(e) =>
                        dispatch({
                          type: "set_agenzie",
                          id: row.id,
                          payload: {
                            ...row,
                            acquistabile: e.target.checked ? 1 : 0,
                          },
                        })
                      }
                      sx={{
                        "&.MuiSwitch-root .MuiSwitch-switchBase": {
                          color: "#ccc",
                        },
                        "&.MuiSwitch-root .Mui-checked": {
                          color: "#407ad6",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <AutocompleteSelect
                      id={`tipoFee/${row.id}`}
                      {...tipoFeeProps}
                      value={row.tipoFee}
                      onChange={(value) =>
                        dispatch({
                          type: "set_agenzie",
                          id: row.id,
                          payload: {
                            ...row,
                            tipoFee: value,
                          },
                        })
                      }
                    />
                    <NumericFormat
                      customInput={TextField}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      sx={{ width: 100 }}
                      id={`fee/${row.id}`}
                      name={`fee/${row.id}`}
                      valueIsNumericString
                      value={row.fee}
                      onValueChange={(e) =>
                        dispatch({
                          type: "set_agenzie",
                          id: row.id,
                          payload: {
                            ...row,
                            fee: e.floatValue, // Add or update the descrizione field
                          },
                        })
                      }
                    />
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableWrapper>
    </Paper>
  );
};

export default Agenzie;
